import { Layout } from '../../style';

export const defaultShifts = {
  _S: Layout.Spacing._S,
  _XS: Layout.Spacing._2XS,
};
